import * as Sentry from '@sentry/nextjs'

import { isTrackingOptedOut } from 'utils/privacyPreferences'

export const setReportingUser = (
  user: { id: number; email?: string } | null
) => {
  if (user && !isTrackingOptedOut()) {
    Sentry.setUser({
      id: String(user.id),
      email: user.email
    })
  } else {
    Sentry.setUser(null)
  }
}
